import { useRef } from 'react'
import { ContentSteps } from 'src/lib/useStepFlow'

import cn from 'classnames'

import { textBtn } from './mock'
import type { TLang } from 'src/constants/langs'
import { CustomButton } from '../../button/CustomButton'
import styles from './styles.module.scss'

type TProps = {
    onClick: () => void
    onNext: (step: ContentSteps) => void
    onAnime: () => void
    step: ContentSteps
    lang: TLang
}

export const FirstStep = ({ onClick, onAnime, onNext, step, lang }: TProps) => {
    const btnRef = useRef<HTMLImageElement>(null)

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    const handleClick = () => {
        onClick()
        setTimeout(() => {
            onAnime()
            setTimeout(() => {
                onNext(step)
            }, 3500)
        }, 500)
    }

    return (
        <div
            ref={btnRef}
            className={cn(styles.wrapper_button, styles.btn_pulse)}
            onClick={handleClick}
        >
            <CustomButton
                textBtn={getBtnTextByLang()}
                classNames={{ textBtn: styles.textBtn }}
            />
        </div>
    )
}
